export default "__VITE_ASSET__CJJZ8DdE__"